export type OpportunitiesPanelsModel = {
    id: string,
    number: number,
    name: string,
    result: ResultEnum,
    created: Date,
    year: number,
    dateFormat: string,
    resultFormat:string,
    action: string
}

export type OpportunitiesPanelsCommentsModel ={
    id: string,
    opportunitesPanelsId: string,
    comments: string,
    result: ResultEnum,
    resultFormat:string,
    created: Date,
    modifiedBy: string,
    createdBy: string
}

export enum ResultEnum{ 
    "Não",
    "Sim",
    "Pendente"
}

